import { Component, OnInit } from '@angular/core';
import { BillingControlService } from '../service/billing-control.service';
import { BcClientListComponent } from '../../bc-client-list/bc-client-list.component';
import { Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';

@Component({
  selector: 'app-bc-effective',
  templateUrl: './bc-effective.component.html',
  styleUrls: ['./bc-effective.component.scss']
})
export class BcEffectiveComponent implements OnInit {

  private BcEffectiveData = [];
  private BcEffectiveTotal = 0;

  //Chart Configuration and Data
  hasLegend = 'true'
  chartType = 'pie'
  private chartData = [
    {
      data: []
    }
  ];
  private chartLabels = [];
  private showChart = false;

  constructor(private billingControlService: BillingControlService, private router: Router, private dialogService: DialogService) {
  }

  ngOnInit() {
    this.getBCEffective();
  }

  getBCEffective() {
    this.billingControlService.getBCEffective().subscribe(result => {
      if (result.Success) {
        this.BcEffectiveData = result.Result || [];
        this.BcEffectiveTotal = result.Total;
        this.defineChartByEffectiveData();
      } else {
        console.log("Erro ao carregar dados de Cobrança Geral");
      }
    }, error => {
      console.log(error);
    });
  }

  defineChartByEffectiveData() {
    if (this.BcEffectiveData.length > 1) {
      this.BcEffectiveData.forEach((row, index) => {
        row.Nome ? this.addChartData(row.Nome, row.Percentual) : this.addChartData('Sem diretoria', row.Percentual);
        if (index == this.BcEffectiveData.length - 1) {
          this.showChart = true;
        }
      });
    }
  }

  addChartData(label, data) {
    const tempChartData = this.chartData[0].data;
    tempChartData.push(data);
    this.chartData[0].data = tempChartData;
    this.chartLabels.push(label);
  }

  toBillingControl(id) {
    const dirId = id ? id : '';
    this.router.navigateByUrl('/').then(
      () => {
        this.router.navigateByUrl('/controle-cobranca/' + dirId);
      });
  }

  openModal(tipo, chave, dias) {
    const objToList = {
      Tipo: tipo,
      Chave: chave == '' ? undefined : chave,
      Dias: dias,
      Diretoria: this.billingControlService.selectedDirectorship
    };
    this.dialogService.addDialog(BcClientListComponent, { obj: objToList }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
  }
}



// WEBPACK FOOTER //
// ./src/app/billing-control/billing-control/bc-effective/bc-effective.component.ts